import { useEffect, useState } from "react";

export default function WeightPriceCalc() {
  const [kg, setKg] = useState("");
  const [qty, setQty] = useState("");
  const [price, setPrice] = useState("");
  const [ans, setAns] = useState(0);

  useEffect(() => {
    if (qty && price) {
      const value = price / qty;
      setAns(Number(value.toFixed(2)));
    } else {
      setAns(0);
    }
  }, [kg, qty, price]);

  return (
    <div className="min-h-screen flex items-center justify-center bg-gray-100 p-4">
      <div className="bg-white p-6 rounded-xl shadow-lg w-full max-w-md">
        <h2 className="text-xl font-bold mb-4 text-center">
          KG / Qty Price Calculator
        </h2>

        {/* KG */}
        <div className="mb-3">
          <label className="block text-sm font-medium mb-1">KG</label>
          <input
            type="number"
            value={kg}
            onChange={(e) => setKg(e.target.value)}
            className="w-full border rounded-lg px-3 py-2"
            placeholder="Enter kg"
          />
        </div>

        {/* QTY */}
        <div className="mb-3">
          <label className="block text-sm font-medium mb-1">Quantity</label>
          <input
            type="number"
            value={qty}
            onChange={(e) => setQty(e.target.value)}
            className="w-full border rounded-lg px-3 py-2"
            placeholder="Enter quantity"
          />
        </div>

        {/* PRICE */}
        <div className="mb-4">
          <label className="block text-sm font-medium mb-1">Price</label>
          <input
            type="number"
            value={price}
            onChange={(e) => setPrice(e.target.value)}
            className="w-full border rounded-lg px-3 py-2"
            placeholder="Enter price"
          />
        </div>

        {/* RESULT */}
        <div className="text-center">
          <p className="text-sm text-gray-500">Answer</p>
          <p className="text-2xl font-bold text-blue-600">{ans}</p>
        </div>
      </div>
    </div>
  );
}
   